import {BitmapText} from "pixi.js";
import {DrawFrmThing} from "../drawfrm/DrawFrmThing";
import {FrmRefPoint} from "../drawfrm/FrmRefPoint";

// reusable text label for 2d scenes. renders via the "Arial" MSDF bitmap font
// registered by DrawFrmApp.waitFonts() — callers must `await app.waitFonts()`
// before the scene renders or BitmapText construction throws. color comes from
// the label's tint, not the style.
const DEFAULT_FONT_SIZE = 10;
const DEFAULT_COLOR = 0x000000;

export type LabelOptions = {
    text: string;
    // anchor within the text box: 0 = left/top, 0.5 = center, 1 = right/bottom.
    // defaults to centered (0.5, 0.5).
    anchorX?: number;
    anchorY?: number;
    fontSize?: number;
    color?: number;
    // rotation in radians. e.g. -Math.PI/2 reads up the line.
    rotation?: number;
};

export class Label extends DrawFrmThing {

    text: BitmapText;

    // anchor sits at the graphic origin (the text's anchor point), so callers
    // can position this label by linking it to another shape's ref point.
    anchor: FrmRefPoint;

    constructor(opt: LabelOptions) {
        super();

        this.text = new BitmapText(opt.text, {
            fontName: "Arial",
            fontSize: opt.fontSize ?? DEFAULT_FONT_SIZE,
        });
        this.text.anchor.set(opt.anchorX ?? 0.5, opt.anchorY ?? 0.5);
        this.text.tint = opt.color ?? DEFAULT_COLOR;
        this.text.rotation = opt.rotation ?? 0;

        this.graphic.addChild(this.text);

        this.anchor = new FrmRefPoint({name: "label:" + opt.text, graphic: this.graphic, staticX: 0, staticY: 0});
    }

    setText(value: string) {
        this.text.text = value;
    }

    setColor(color: number) {
        this.text.tint = color;
    }
}
